import { useState, useEffect } from "react";
import { Image } from 'react-bootstrap';

const Carousel = () => {
  const slides = [
    {
      img: "/img-header.png",
      title: "Building Resilient Communities and Transforming Lives",
      desc: "We continuously seek innovative ways to enhance our service offerings and operational efficiency.",
    },
    {
      img: "/about.png",
      title: "Empowering Change Through Collaboration",
      desc: "Together, we can create lasting impact in the communities we serve.",
    },
    {
      img: "/metal-health1.png",
      title: "Sustainable Growth for Future Generations",
      desc: "We are committed to building solutions that stand the test of time.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Go to next slide
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  // Go to previous slide
  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  return (
    <section className="carousel-container">
      <div className="carousel-content-one">
        <Image
          src={slides[currentIndex].img}
          alt="Hero"
          className="img-fluid hero-img"
          width={800}
          height={600}
        />
      </div>

      <div className="carousel-content-two">
        <div className="carousel-text-content">
          <h1 className="carousel-text-h1 wow animate__animated animate__fadeInUp" data-wow-duration="1s">
            {slides[currentIndex].title}
          </h1>
          <p className="carousel-text-p wow animate__animated animate__fadeInUp" data-wow-duration="1.8s">
            {slides[currentIndex].desc}
          </p>

          <div className="d-flex gap-3 mt-4">
            
            {/* <button className="cta btnFill wow animate__animated animate__fadeInUp" data-wow-duration="2.5s">
              Donate Now
            </button> */}
            {/* <button className="btnBorder wow animate__animated animate__fadeInUp" data-wow-duration="2.5s">
              Join our mission
            </button> */}
                        <a
  href="https://www.zeffy.com/en-CA/donation-form/donate-to-change-lives-184"
  target="_blank"
  rel="noopener noreferrer"
  className="cta btnFill wow animate__animated animate__fadeInUp" 
  data-wow-duration="2.5s"
>
 Donate Now
</a>
            <a
  href="https://www.zeffy.com/en-CA/donation-form/donate-to-change-lives-184"
  target="_blank"
  rel="noopener noreferrer"
  className="btnBorder wow animate__animated animate__fadeInUp" 
  data-wow-duration="2.5s"
>
  Join our mission
</a>
                
            
          </div>
        </div>

        <div className="box-indicators">
          <span className="carousel-btn" onClick={handlePrev}>
            &larr; {currentIndex + 1}</span>
          <span className="carousel-btn"> / </span>
          <span className="carousel-btn" onClick={handleNext}>3  &rarr;</span>
        </div>
      </div>
    </section>
  );
};

export default Carousel;
